<template>
    <div>
        <loading-progress-bar v-if="loading && !bareMode" :loading="loading" color="secondary"></loading-progress-bar>
        <div v-if="bareMode">
            <v-data-table
                    :headers="headers"
                    disable-initial-sort
                    :items="filteredItems"
                    class="elevation-1"
                    :search="search"
                    :rows-per-page-items="showAllOnOnePage ? [-1] : [10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    :pagination.sync="pagination"
            >
                            <template v-slot:items="props">
                                <td v-if="visibleColumns.includes('notification_id')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.notification_id }}</td>
                                <td v-if="visibleColumns.includes('title')" @click="callDialog(props.item)" class="cursor-as-pointer">{{ props.item.title }}</td>
                                <td v-if="visibleColumns.includes('equip')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.equip }}</td>
                                <td v-if="visibleColumns.includes('equipType')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.equipType }}</td>
                                <td v-if="visibleColumns.includes('topic')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.topic }}</td>
                                <td v-if="visibleColumns.includes('floor')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.floor }}</td>
                                <td v-if="visibleColumns.includes('description')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer caption">{{ props.item.description }}</td>
                                <td v-if="visibleColumns.includes('startDate')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{props.item.startDate}}</td>
                                <td v-if="visibleColumns.includes('endDate')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{props.item.endDate}}</td>
                                <td v-if="visibleColumns.includes('severity')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <severity-chip :value="props.item.severity"></severity-chip>
                                </td>
                                <td v-if="showMaintenanceRecords && visibleColumns.includes('assigned_to')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <ul v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <li v-for="i in Array.from(new Set(props.item.maintenance_records.filter(x=>!x.is_fixed&&x.assigned_to&&x.assigned_to!=='').map(x=>x.assigned_to)))" :key="i">{{ i }}</li>
                                    </ul>
                                </td>
                                <td v-if="showMaintenanceRecords && visibleColumns.includes('is_fixed')" class="text-xs-center">
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-badge
                                                    color="warning"
                                                    overlap
                                                >
                                                    <template v-slot:badge
                                                              v-if="props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                                        <span>{{ props.item.maintenance_records.length }}</span>
                                                    </template>
                                                <v-icon v-on="on" class="ml-2 mr-1" color="warning"
                                                        @click="callDialog(props.item)">fa-times
                                                </v-icon>
                                                </v-badge>
                                            </v-badge>
                                        </template>
                                        <span>{{ props.item.maintenance_records.length }} {{ 'Maintenance Records'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length===0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-icon v-on="on" @click="callDialog(props.item)" color="success" class="ml-1">fa-check</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{ 'Maintenance Completed'|translate }} </span>
                                    </v-tooltip>
                                </td>
                                <td v-if="visibleColumns.includes('acknowledged')" class="text-xs-center">
                                    <template v-if="$can('update', 'Notification')">
                                        <template v-if="!props.item.acknowledged">
                                            <v-btn icon
                                                   @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=true;">
                                                <v-icon color="warning">fa-bell</v-icon>
                                            </v-btn>
                                        </template>
                                        <template v-else>
                                            <v-btn icon
                                                   @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=false;">
                                                <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                            </v-btn>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning">fa-bell</v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                        </template>
                                    </template>
                                </td>
                                <td v-if="visibleColumns.includes('actions')" class="text-xs-center">
                                    <v-icon small class="mr-2" @click="callDialog(props.item)">
                                        fa-info
                                    </v-icon>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="callMaintenanceDialog(props.item)"
                                            >
                                                fa-notes-medical
                                            </v-icon>
                                        </template>
                                        <span>{{'Add maintenance record'|translate}} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="jumpToLink(props.item)"
                                            >
                                                fa-chart-line
                                            </v-icon>
                                        </template>
                                        <span>{{'View chart'|translate}} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="showMuteAction && !props.item.muted">
                                        <template v-slot:activator="{ on }">
                                            <v-icon small v-on="on"
                                                    @click="muteNotif(props.item.notification_id, true);props.item.muted=true;"
                                            >
                                                fa-volume-up
                                            </v-icon>
                                        </template>
                                        <span>{{ 'Mute'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="showMuteAction && props.item.muted">
                                        <template v-slot:activator="{ on }">
                                            <v-icon small v-on="on"
                                                    @click="muteNotif(props.item.notification_id, false);props.item.muted=false;"
                                            >
                                                fa-volume-mute
                                            </v-icon>
                                        </template>
                                        <span>{{ 'Un-Mute'|translate }} </span>
                                    </v-tooltip>
                                </td>
                            </template>
                            <template v-slot:no-data>
                                <span>{{'No Result'|translate}}</span>
                            </template>
                        </v-data-table>
        </div>
        <v-layout v-else row wrap>
            <v-flex xs12>
                <v-card flat>
                    <v-card-title v-if="title" class="primary white--text headline">
                        {{title|translate}}
                    </v-card-title>
                    <v-layout row wrap v-if="!hideFilters">
                        <v-flex xs3>
                            <v-switch color="success" class="ml-4" v-model="showRecentInWidget" :label="'Show Unack Notifications Only'|translate"></v-switch>
                        </v-flex>
                        <v-flex xs3>
                            <v-text-field class="mr-4" clearable v-model="search" type="text" :label="'Keyword filter'|translate"></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                            <v-select
                                color="white"
                                :items="severities"
                                class="mx-4"
                                multiple
                                :label="'Severity filter'|translate"
                                v-model="severity">
                            </v-select>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-btn class="accent" @click="exportNotification">
                            <v-icon small class="mr-2">fa-download</v-icon>
                            {{'Download'|translate}}
                        </v-btn>
                    </v-layout>
                    <v-card-text>
                        <v-data-table
                                :headers="headers"
                                disable-initial-sort
                                :items="filteredItems"
                                class="elevation-1"
                                :search="search"
                                :rows-per-page-items="showAllOnOnePage ? [-1] : [10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                :pagination.sync="pagination"
                        >
                            <template v-slot:items="props">
                                <td v-if="visibleColumns.includes('notification_id')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.notification_id }}</td>
                                <td v-if="visibleColumns.includes('title')" @click="callDialog(props.item)" class="cursor-as-pointer">{{ props.item.title }}</td>
                                <td v-if="visibleColumns.includes('equip')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.equip }}</td>
                                <td v-if="visibleColumns.includes('equipType')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.equipType }}</td>
                                <td v-if="visibleColumns.includes('topic')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.topic }}</td>
                                <td v-if="visibleColumns.includes('floor')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{ props.item.floor }}</td>
                                <td v-if="visibleColumns.includes('description')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer caption">{{ props.item.description }}</td>
                                <td v-if="visibleColumns.includes('startDate')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{props.item.startDate}}</td>
                                <td v-if="visibleColumns.includes('endDate')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">{{props.item.endDate}}</td>
                                <td v-if="visibleColumns.includes('severity')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <severity-chip :value="props.item.severity"></severity-chip>
                                </td>
                                <td v-if="showMaintenanceRecords && visibleColumns.includes('assigned_to')" @click="callDialog(props.item)" class="text-xs-left cursor-as-pointer">
                                    <ul v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0">
                                        <li v-for="i in Array.from(new Set(props.item.maintenance_records.filter(x=>!x.is_fixed&&x.assigned_to&&x.assigned_to!=='').map(x=>x.assigned_to)))" :key="i">{{ i }}</li>
                                    </ul>
                                </td>
                                <td v-if="showMaintenanceRecords && visibleColumns.includes('is_fixed')" class="text-xs-center">
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-badge
                                                    color="warning"
                                                    overlap
                                                >
                                                    <template v-slot:badge
                                                              v-if="props.item.maintenance_records.filter(x=>!x.is_fixed).length>0">
                                                        <span>{{ props.item.maintenance_records.length }}</span>
                                                    </template>
                                                <v-icon v-on="on" class="ml-2 mr-1" color="warning"
                                                        @click="callDialog(props.item)">fa-times
                                                </v-icon>
                                                </v-badge>
                                            </v-badge>
                                        </template>
                                        <span>{{ props.item.maintenance_records.length }} {{ 'Maintenance Records'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom
                                               v-if="props.item.maintenance_records&&props.item.maintenance_records.length>0&&props.item.maintenance_records.filter(x=>!x.is_fixed).length===0">
                                        <template v-slot:activator="{ on }">
                                            <v-badge
                                                color="accent"
                                                overlap
                                            >
                                                <v-icon v-on="on" @click="callDialog(props.item)" color="success" class="ml-1">fa-check</v-icon>
                                            </v-badge>
                                        </template>
                                        <span>{{ 'Maintenance Completed'|translate }} </span>
                                    </v-tooltip>
                                </td>
                                <td v-if="visibleColumns.includes('acknowledged')" class="text-xs-center">
                                    <template v-if="$can('update', 'Notification')">
                                        <template v-if="!props.item.acknowledged">
                                            <v-btn icon
                                                   @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=true;">
                                                <v-icon color="warning">fa-bell</v-icon>
                                            </v-btn>
                                        </template>
                                        <template v-else>
                                            <v-btn icon
                                                   @click="trigger(props.item.notification_id, props.item.acknowledged);props.item.acknowledged=false;">
                                                <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                            </v-btn>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="!props.item.acknowledged">
                                            <v-icon color="warning">fa-bell</v-icon>
                                        </template>
                                        <template v-else>
                                            <v-icon style="color:lightgrey">fa-bell-slash</v-icon>
                                        </template>
                                    </template>
                                </td>
                                <td v-if="visibleColumns.includes('actions')" class="text-xs-center justify-center layout px-0">
                                    <v-icon small class="mr-2" @click="callDialog(props.item)">
                                        fa-info
                                    </v-icon>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="callMaintenanceDialog(props.item)"
                                            >
                                                fa-notes-medical
                                            </v-icon>
                                        </template>
                                        <span>{{'Add maintenance record'|translate}} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on"
                                                    small
                                                    class="mr-2"
                                                    @click="jumpToLink(props.item)"
                                            >
                                                fa-chart-line
                                            </v-icon>
                                        </template>
                                        <span>{{'View chart'|translate}} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="showMuteAction && !props.item.muted">
                                        <template v-slot:activator="{ on }">
                                            <v-icon small v-on="on"
                                                    @click="muteNotif(props.item.notification_id, true);props.item.muted=true;"
                                            >
                                                fa-volume-up
                                            </v-icon>
                                        </template>
                                        <span>{{ 'Mute'|translate }} </span>
                                    </v-tooltip>
                                    <v-tooltip bottom v-if="showMuteAction && props.item.muted">
                                        <template v-slot:activator="{ on }">
                                            <v-icon small v-on="on"
                                                    @click="muteNotif(props.item.notification_id, false);props.item.muted=false;"
                                            >
                                                fa-volume-mute
                                            </v-icon>
                                        </template>
                                        <span>{{ 'Un-Mute'|translate }} </span>
                                    </v-tooltip>
                                </td>
                            </template>
                            <template v-slot:no-data>
                                <span>{{'Equipment' | translate}} {{equipment}} {{'No Relevant Notifications'|translate}} </span>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <notification-detail-dialog
            v-model="dialog"
            :item="currentItem"
            :maintenance-headers="maintenanceHeaders"
            @jump-to-link="jumpToLink"
            @jump-to-link-nw="jumpToLinkNW"
            @trigger="trigger"
            @mute="muteNotif"
            @refresh="refresh"
        ></notification-detail-dialog>
        <fault-record-dialog
            v-model="maintenanceDialog"
            :item="maintenanceItem"
        ></fault-record-dialog>
    </div>
</template>

<script>
import {getNotification, putNotification} from '@/helper'
import LoadingProgressBar from '../LoadingProgressBar'
import FaultRecordDialog from '../FaultRecordDialog'
import SeverityChip from '../SeverityChip'
import {exportCSV} from '@/tocsv'
import _ from 'lodash'
import moment from 'moment'
import NotificationDetailDialog from '../NotificationDetailDialog'

export default {
    props: {
        title: {type: String, default: null},
        dateRange: {type: Object, default: null},
        equipment: {type: String, default: null},
        whiteMode: {type: Boolean, default: false},
        hideFilters: {type: Boolean, default: false},
        showAllOnOnePage: {type: Boolean, default: false},
        defaultSeverities: {type: Array, default: () => ['critical', 'high', 'medium', 'low']},
        externalItems: {type: Array, default: null},
        showMaintenanceRecords: {type: Boolean, default: false},
        showMuteAction: {type: Boolean, default: false},
        bareMode: {type: Boolean, default: false},
        showRecent: {type: Boolean, default: true},
        severityFilter: {type: [Array, String], default: function (){return []}},
        topicFilter: {type: [Array, String], default: ''},
        visibleColumnsString: { type: String, default: ''}
    },
    components: {LoadingProgressBar, FaultRecordDialog, SeverityChip, NotificationDetailDialog},
    name: 'NotificationListWidget',
    watch: {
        showRecent(value) {
          this.showRecentInWidget = value
          //this.refresh()
        },
        dateRange() {
            this.refresh()
        },
        equipment() {
            this.refresh()
        },
        externalItems: {
            immediate: true,
            handler(newVal) {
                if (newVal !== null) {
                    this.loading = false
                }
            }
        }
    },
    data: function () {
        return {
            loading: true,
            timeout: null,
            dialog: false,
            maintenanceDialog: false,
            maintenanceItem: null,
            showRecentInWidget: true,
            items: [],
            severities: ['critical', 'high', 'medium', 'low', 'info'],
            severity: this.defaultSeverities,
            search: '',
            currentItem: {
                icon: 'fa-bell',
                title: '',
                equip: '',
                startDate: '',
                endDate: '',
                to: {
                    path: '/sensors',
                    query: {}
                },
                description: '',
                recommendedActions: '',
                maintenance_records: [],
                acknowledged: false,
                notification_id: null,
                ack_by: null,
                last_ack_date: null,
                muted_by: null,
                muted_date: null
            },
            pagination: {},
            maintenanceHeaders: [
                {
                    text: this.$options.filters.translate('ID'),
                    align: 'left',
                    sortable: true,
                    value: 'maintenance_id'
                },
                {
                    text: this.$options.filters.translate('Fault'),
                    align: 'left',
                    sortable: true,
                    value: 'maintenance_label'
                },
                {text: this.$options.filters.translate('Fixed'), value: 'is_fixed'},
                {text: this.$options.filters.translate('Assigned to'), value: 'assigned_to'},
                {text: this.$options.filters.translate('Assigned by'), value: 'assigned_by'},
                {text: this.$options.filters.translate('Assigned date'), value: 'assigned_date'},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
        }
    },
    computed: {
        visibleColumns() {
            if (this.visibleColumnsString === '') {
                return [
                    'notification_id',
                    'title',
                    'equip',
                    'equipType',
                    'topic',
                    'floor',
                    'description',
                    'startDate',
                    'endDate',
                    'severity',
                    'assigned_to',
                    'is_fixed',
                    'acknowledged',
                    'actions'
                ]
            }
            return this.visibleColumnsString.split(',').map(col => col.trim())
        },
        headers() {
            // Define all possible headers
            const allHeaderDefinitions = {
                notification_id: {
                    text: this.$options.filters.translate('ID'),
                    align: 'left',
                    sortable: true,
                    value: 'notification_id'
                },
                title: {
                    text: this.$options.filters.translate('Alerts'),
                    align: 'left',
                    sortable: true,
                    value: 'title'
                },
                equip: {
                    text: this.$options.filters.translate('Equipment'),
                    align: 'left',
                    sortable: true,
                    value: 'equip'
                },
                equipType: {
                    text: this.$options.filters.translate('Equipment Type'),
                    align: 'left',
                    sortable: true,
                    value: 'equipType'
                },
                topic: {
                    text: this.$options.filters.translate('Topic'),
                    align: 'left',
                    sortable: true,
                    value: 'topic'
                },
                floor: {
                    text: this.$options.filters.translate('Floor'),
                    align: 'left',
                    sortable: true,
                    value: 'floor'
                },
                description: {
                    text: this.$options.filters.translate('Description'),
                    align: 'left',
                    sortable: true,
                    value: 'description'
                },
                startDate: {
                    text: this.$options.filters.translate('Start Date'),
                    align: 'left',
                    sortable: true,
                    value: 'startDate'
                },
                endDate: {
                    text: this.$options.filters.translate('End Date'),
                    align: 'left',
                    sortable: true,
                    value: 'endDate'
                },
                severity: {
                    text: this.$options.filters.translate('Severity'),
                    align: 'left',
                    sortable: true,
                    value: 'severity'
                },
                assigned_to: {
                    text: this.$options.filters.translate('Assigned to'),
                    align: 'left',
                    sortable: true,
                    value: 'assigned_to'
                },
                is_fixed: {
                    text: this.$options.filters.translate('Fixed'),
                    align: 'left',
                    sortable: true,
                    value: 'is_fixed'
                },
                acknowledged: {
                    text: this.$options.filters.translate('Acknowledged'),
                    align: 'left',
                    sortable: true,
                    value: 'acknowledged'
                },
                actions: {
                    text: this.$options.filters.translate('Actions'),
                    align: 'left',
                    sortable: false,
                    value: 'actions'
                }
            }
            
            // Build headers array based on visibleColumns
            const headers = []
            for (const columnValue of this.visibleColumns) {
                // Skip maintenance columns if showMaintenanceRecords is false
                if ((columnValue === 'assigned_to' || columnValue === 'is_fixed') && !this.showMaintenanceRecords) {
                    continue
                }
                
                // Add header if it exists in definitions
                if (allHeaderDefinitions[columnValue]) {
                    headers.push(allHeaderDefinitions[columnValue])
                }
            }
            
            return headers
        },
        displayItems() {
            return this.externalItems !== null ? this.externalItems : this.items
        },
        filteredItems() {
            let result = this.displayItems
            if (this.showRecentInWidget) {
                result = result.filter(x => !x.acknowledged)
            }
            let configuredSeverityFilter = this.normalizeFilter(this.severityFilter)
            if (configuredSeverityFilter.length > 0) {
                result = result.filter(x => configuredSeverityFilter.includes(x.severity ? x.severity.toLowerCase() : ''))
            } else if (this.severity && this.severity.length > 0) {
                let severityFilter = this.normalizeFilter(this.severity)
                result = result.filter(x => severityFilter.includes(x.severity ? x.severity.toLowerCase() : ''))
            }
            result = result.filter(x => this.notificationMatchesTopicFilter(x))
            return result
        }
    },
    mounted() {
        if (this.externalItems === null) {
            this.refresh()
        }
    },
    methods: {
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.getData, 500);
        },
        normalizeFilter(value) {
            if (!value) {
                return []
            }
            let values = Array.isArray(value) ? value : String(value).split(',')
            return values.map(x => String(x).trim().toLowerCase()).filter(x => x !== '')
        },
        notificationMatchesTopicFilter(notification) {
            let topicFilter = this.normalizeFilter(this.topicFilter)
            let topic = notification.topic ? notification.topic.toLowerCase() : ''
            return topicFilter.length === 0 || topicFilter.includes(topic)
        },
        async trigger(id, state) {
            await putNotification(
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'notification_id': id,
                    'show_flag': state
                }
            )
            // Update local state
            if (this.currentItem && this.currentItem.notification_id === id) {
                this.currentItem.acknowledged = !state
            }
        },
        async muteNotif(id, state) {
            await putNotification(
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'notification_id': id,
                    'mute_notif': state
                }
            )
            // Update local state
            if (this.currentItem && this.currentItem.notification_id === id) {
                this.currentItem.muted = state
            }
        },
        exportNotification() {
            let cleanedItems = JSON.parse(JSON.stringify(this.filteredItems))
            for (let item of cleanedItems) {
                item.url = window.location.origin + this.$router.resolve(this.getItemUrl(item)).href
                delete (item.to)
                delete (item.icon)
                delete (item.notification_id)
            }
            exportCSV(cleanedItems)
        },
        getMaintenanceItem(item) {
            let itemUrlObj = this.getItemUrl(item)
            return {
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                equipment: item['equip'],
                maintenance_date_from: item['startDate'],
                maintenance_date_to: item['endDate'],
                severity: item['severity'],
                maintenance_text: 'Recommended Actions: \n\n' + item['recommendedActions'],
                maintenance_label: item['title'],
                url: this.$router.resolve(itemUrlObj).href,
                is_fixed: false,
                notification_id: item['notification_id'],
                maintenance_id: null
            }
        },
        callMaintenanceDialog(item, dialogOpen = true) {
            this.maintenanceItem = this.getMaintenanceItem(item)
            this.maintenanceDialog = dialogOpen
        },
        callDialog(item) {
            this.dialog = true
            this.currentItem = item
        },
        getItemUrl(item) {
            let output = null;
            if (item.title.substring(0, 7) === "Anomaly") {
                output = {
                    path: '/modelsummary',
                    query: {
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                        equipment: item.equip
                    }
                }
            } else if (item.topic === "equipment health") {
                output = {
                    path: '/equipment-health',
                    query: {
                        equipment: item.equip,
                    }
                }
            } else {
                output = {
                    path: '/fault-analysis',
                    query: {
                        relevantVariables: item.to.query.variableX,
                        faultName: item.title,
                        faultDesc: item.description,
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                        equipmentName: item.equip,
                        nId: item.notification_id,
                        nTopic: item.topic,
                        nOct: item.occurredTimes
                    }
                }
            }
            return output
        },
        jumpToLink(item) {
            let output = this.getItemUrl(item)
            if (item.to && item.to.external_domain) {
                window.open(item.to.external_domain + this.$router.resolve(output).href)
            } else {
                this.$router.push(output)
            }
        },
        jumpToLinkNW(item) {
            let output = this.getItemUrl(item)
            if (process.env.VUE_APP_SINGLE_WINDOW_MODE) {
                this.$router.push(output)
            } else {
                if (item.to && item.to.external_domain) {
                    window.open(item.to.external_domain + this.$router.resolve(output).href)
                } else {
                    window.open(this.$router.resolve(output).href)
                }
            }
        },
        async getData() {
            if (this.dateRange) {
                this.loading = true
                let notifResult = await getNotification({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    date_range: [this.dateRange.start, moment(this.dateRange.end).format('YYYY-MM-DD') + " 23:59:59"],
                })
                let notifs = notifResult.result
                let items = []
                for (let i in notifs) {
                    items.push({
                        icon: 'fa-bell',
                        alertType: notifs[i]['model'],
                        title: notifs[i]['title'],
                        equip: notifs[i]['equipment_name'],
                        equipType: notifs[i]['equipment_type'],
                        floor: notifs[i]['floor'],
                        startDate: notifs[i]['start_date'],
                        endDate: notifs[i]['end_date'],
                        topic: notifs[i]['topic'],
                        occurredTimes: notifs[i]['occurred_times'],
                        to: notifs[i]['to'],
                        description: notifs[i]['description'],
                        recommendedActions: notifs[i]['recommended_actions'],
                        severity: notifs[i]['severity'],
                        notification_id: notifs[i]['notification_id'],
                        acknowledged: notifs[i]['acknowledged'],
                        ack_by: notifs[i]['ack_by'],
                        last_ack_date: notifs[i]['last_ack_date'],
                        muted_by: notifs[i]['muted_by'],
                        muted_date: notifs[i]['muted_date'],
                    })
                }
                // Filter by equipment if provided
                if (this.equipment && this.equipment !== "") {
                    items = items.filter(x => x.equip === this.equipment)
                }
                this.items = _.sortBy(items, ['startDate']).reverse()
                this.loading = false
            }
        }
    },
}
</script>
